import React from 'react'

export const UserDispatch = React.createContext(null);